var map = {
	"./et2020": 39,
	"./et2020.js": 39,
	"./et2020/article": 21,
	"./et2020/article.js": 21,
	"./et2020/compiled.png": 28,
	"./et2020/thumbnail.jpg": 40,
	"./gk2019": 41,
	"./gk2019.js": 41,
	"./gk2019/article": 22,
	"./gk2019/article.js": 22,
	"./gk2019/compiled.png": 29,
	"./gk2019/statistics.png": 30,
	"./gk2019/thumbnail.jpg": 42,
	"./suryaputra_web": 43,
	"./suryaputra_web.js": 43,
	"./suryaputra_web/article": 23,
	"./suryaputra_web/article.js": 23,
	"./suryaputra_web/thumbnail.jpg": 44
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38;